<template>
  <div class="overlay">
    <div>
      <div>
        <v-card>
          <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
          </v-overlay>

          <v-form ref="form" v-model="valid" lazy-validation v-if="firstStep || secondStep">
            <v-card>
              <v-card-title>
                <div style="display: flex; justify-content: space-between; width: 100%">
                  <span class="text-h5"> Registrar Novo Estudante</span>
                  <div>
                    <v-btn text @click="FecharCard"><v-icon large color="red">clear</v-icon></v-btn>
                  </div>
                </div>
              </v-card-title>


              <v-card-text>
                <v-container>
                  <transition name="slide">
                    <div v-if="firstStep" key="firstStep" class="slide-item">
                      <div style=" display: flex; flex-direction: column; align-items: center;">
                        <div style="display: flex; flex-direction: row; align-items: center;">
                          <div style="width: 300px">
                            <v-text-field ref="biField" required :rules="ruleBI" v-model="editedItem.bi" :label="descricao" v-mask="mascara"></v-text-field>
                          </div>
                          <div style="margin-left: 10px">
                            <v-switch @change="outroDoc()"></v-switch>
                          </div>
                        </div>
                        <div style="margin-top: 10px">
                          <v-btn color="primary" :disabled="!valid" @click="checkDocNumber()"> Avançar </v-btn>
                        </div>
                      </div>
                    </div>
                  </transition>

                  <transition name="slide">
                    <div v-if="secondStep" key="secondStep" class="slide-item">
                      <div style=" display: flex; flex-direction: column; align-items: center;">
                        <v-row>
                          <v-col cols="4" sm="4" md="4">
                            <v-text-field :rules="ruleTextRequired" v-model="editedItem.nome" label="Nome"></v-text-field>
                          </v-col>

                          <v-col cols="4" sm="4" md="4">
                            <v-text-field v-if="!editarDados" v-model="editedItem.bi" :disabled="true" :label="descricao"></v-text-field>
                          </v-col>

                          <v-col cols="4" sm="4" md="4">
                            <template>
                              <v-menu ref="menubi" :rules="ruleTextRequired" v-model="menubi"
                                :close-on-content-click="false" transition="scale-transition" offset-y full-width
                                min-width="290px">
                                <template v-slot:activator="{ on }">
                                  <v-text-field v-model="editedItem.dataemissaobi"
                                    :rules="[(v) => !!v || 'Campo obrigatorio!']" label="Data de emissâo do BI"
                                    prepend-icon="event" readonly v-on="on"></v-text-field>
                                </template>
                                <v-date-picker ref="picker" max="2027-12-31" min="1980-01-01" v-model="datebi"
                                  @change="saveDatebi"></v-date-picker>
                              </v-menu>
                            </template>
                          </v-col>

                          <v-col cols="4" sm="4" md="4">
                            <v-text-field v-model="editedItem.nomedopai" label="Filho de:"></v-text-field>
                          </v-col>

                          <v-col cols="4" sm="4" md="4">
                            <v-text-field v-model="editedItem.nomedamae" label=" e de:"></v-text-field>
                          </v-col>

                          <v-col cols="4" sm="4" md="4">
                            <template>
                              <v-menu ref="menu" v-model="menu" :close-on-content-click="false"
                                transition="scale-transition" offset-y full-width min-width="290px">
                                <template v-slot:activator="{ on }">
                                  <v-text-field v-model="editedItem.datanascimento"
                                    :rules="[(v) => !!v || 'Campo obrigatorio!']" label="Data de nascimento"
                                    prepend-icon="event" readonly v-on="on"></v-text-field>
                                </template>
                                <v-date-picker ref="picker" v-model="date" max="2022-12-31" min="1990-01-01"
                                  @change="saveDate"></v-date-picker>
                              </v-menu>
                            </template>
                          </v-col>

                          <v-col cols="4" sm="4" md="4">
                            <div class="tpaCombox">
                              <v-combobox :rules="ruleRequired" v-model="editedItem.provincia" :items="provincias"
                                item-value="idProvicia" item-text="descricao" @change="loadMunicipioComb"
                                @click="loadMunicipioComb" return-object rounded label="Natural de:"></v-combobox>
                            </div>
                          </v-col>

                          <v-col cols="4" sm="4" md="4">
                            <div class="tpaCombox">
                              <v-combobox :rules="ruleRequired" v-model="editedItem.municipio" :disabled="!editedItem.provincia"
                                :items="municipiosFiltered" item-value="idMunicipio" item-text="descricao" return-object
                                label="Município" rounded></v-combobox>
                            </div>
                          </v-col>

                          <v-col cols="4" sm="4" md="4">
                            <div class="tpaCombox">
                              <v-combobox :rules="ruleRequired" v-model="editedItem.sexo" :items="dropdowSexo"
                                item-value="idSexo" item-text="descricao" return-object label="Sexo"
                                rounded></v-combobox>
                            </div>
                          </v-col>

                          <v-col cols="4" sm="4" md="4">
                            <v-text-field v-model="editedItem.telefone" label=" Telefone:"></v-text-field>
                          </v-col>

                          <v-col cols="4" sm="4" md="4" v-if="!editarDados" :md='4'>
                            <div class="tpaCombox">
                              <v-combobox v-model="editedItem.curso" :rules="ruleRequired" item-value="idCurso"
                                item-text="descricao" @change="loadclasse" :items="cursos" return-object label="Curso"
                                rounded></v-combobox>
                            </div>
                          </v-col>

                          <v-col cols="4" sm="4" md="4" v-if="!editarDados" :md='4'>
                            <div class="tpaCombox">
                              <v-combobox v-model="editedItem.classeSelected" :rules="ruleRequired" :disabled="!editedItem.curso"
                                item-text="descricao" :items="classesFiltered" @change="loadTurmaComb" return-object
                                :label="nivelEnsino === 1 ? 'Selecione o ano académico' : 'Selecione a classe'" rounded></v-combobox>
                            </div>
                          </v-col>

                          <v-col cols="4" sm="4" md="4" v-if="!editarDados" :md='4'>
                            <div class="tpaCombox">
                              <v-combobox id="turma" v-model="editedItem.turma" :rules="ruleRequired" :value="undefined"
                                item-value="idTurma" item-text="turmadescricao" :items="turmasFiltered" return-object
                                label="Turma" @change="ObterNumeroEstudantesTurma()" 
                                :disabled="blockCadastro || blockCadastroClasse || !editedItem.classeSelected" rounded></v-combobox>
                            </div>
                          </v-col>

                          <v-col cols="4" sm="4" md="4">
                            <div class="tpaCombox">
                              <v-combobox v-if="!editarDados" v-model="editedItem.periodo" :rules="ruleRequired"
                                :disabled="true" item-value="id" item-text="descricao" :items="periodos" return-object
                                rounded label="Período"></v-combobox>
                            </div>
                          </v-col>

                          <v-col cols="4">
                            <div class="containerTurma"
                              v-if="editedItem.turma || editedItem.classeSelected.id && !blockCadastroClasse">

                              <!-- Capacidade da Turma e Nº Estudantes -->
                              <div v-if="editedItem.turma">
                                <span class="boldText">Capacidade da Turma:</span>
                                <span>{{ editedItem.turma.capacidade }}</span>
                              </div>

                              <div v-if="editedItem.turma">
                                <span class="boldText">Nº Estudantes na Turma:</span>
                                <span>{{ numeroEstudantesCadastrado.length ? numeroEstudantesCadastrado[0].qtdEstudante
                                  : 0 }}</span>
                              </div>

                              <!-- Vagas disponíveis -->
                              <div v-if="editedItem.turma">
                                <span class="boldText">Vagas disponíveis:</span>
                                <span
                                  :style="vagasDisponiveis > 0 ? 'color:green;font-weight:bold;' : 'color:red;font-weight:bold;'">
                                  {{ vagasDisponiveis > 0 ? vagasDisponiveis : 0 }}
                                </span>
                              </div>

                              <!-- Dados por classe (cadastrados e permitidos) -->
                              <div v-for="classe in [1, 2, 3, 4]" :key="classe">
                                <div v-if="editedItem.classeSelected.id == classe">
                                  <span class="boldText">Total Cadastrados ({{ classe + 9 }}ª):</span>
                                  <span>{{ estudantesCadastrados['classe' + classe] }}</span>
                                </div>
                                <div v-if="editedItem.classeSelected.id == classe">
                                  <span class="boldText">Estudantes Permitidos ({{ classe + 9 }}ª):</span>
                                  <span>{{ estatisticas['classe' + classe] }}</span>
                                </div>
                              </div>
                              <span v-if="blockCadastro" class="alertMessage">OBS: {{ result }}</span>
                            </div>
                          </v-col>
                        </v-row>
                      </div>
                    </div>
                  </transition>
                </v-container>
              </v-card-text>
              <v-card-actions v-if="secondStep">
                <v-spacer></v-spacer>
                <v-btn color="primary darken-1" text @click="voltarParaPrimeiroStep()"> voltar </v-btn>
                <v-btn color="green darken-1" text :disabled="!valid || vagasDisponiveis <= 0 || blockCadastro"
                  @click="Guardar()">
                  Guardar </v-btn>
              </v-card-actions>
            </v-card>
          </v-form>
        </v-card>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "@/plugins/axios";
import { mask } from "vue-the-mask";
import utilitarios from "@/plugins/utilitarios";
import Swal from "sweetalert2";
const ls = require("local-storage");
export default {
  directives: { mask },
  name: "NovoEstudante",
  data: () => ({
    result: '',
    mascara: "#########-AA-###",
    editarDados: false,
    overlay: false,
    valid: true,
    ruleTextRequired: [
      (value) => !!value || "campo obrigatório.",
      (value) =>
        (value || "").length <= 70 || "O máximo número de carácters atigidos",
      (value) => (value || "").length > 3 || "carácteres insuficientes",
      (value) => {
        const pattern = /(([{;=+~_!@#$%^&*()/,.?":{}|<>},{0-9}]))$/;
        return !pattern.test(value) || "Invalido.";
      },
    ],
    ruleBI: [
      (value) => !!value || "campo obrigatório.",
      (value) => value.length === 16 || "Minimo de caracteres exigido( 16 ).",
    ],
    editedItem: {
      pk_estudante: 0,
      numeroProcesso: "",
      pkPessoa: 0,
      classeSelected: "",
      bi: "",
      idPessoa: "",
      municipio: null,
      idPerfil: null,
      nome: "",
      morada: "",
      telefone: "",
      autor: "",
      datanascimento: "",
      data_: "",
      status_2: "",
      email: "",
      sexo: "",
      periodo: "",
      nomedopai: "",
      nomedamae: "",
      numeroProcesso: null,
      dataemissaobi: null,
      provincia: null,
      instituicao: null,
      instituicaodescricao: "",
      curso: null,
      turma: null,
      numeroProcesso: "",
      matriculaAntiga: "",
    },
    descricao: "Nº do Bi",
    menubi: false,
    datebi: null,
    menu: false,
    ruleRequired: [(value) => !!value || "campo obrigatorio"],
    provincias: [],
    municipiosFiltered: [],
    dropdowSexo: [
      { idSexo: "M", descricao: "Masculino" },
      { idSexo: "F", descricao: "Femenino" },
    ],
    cursos: [],
    classesFiltered: [],
    turmasAll: [],
    turmasFiltered: [],
    municipiosAll: [],
    numeroEstudantesCadastrado: [],
    periodos: [
      { id: "M", descricao: "Manhã" },
      { id: "T", descricao: "Tarde" },
      { id: "N", descricao: "Noite" },
    ],
    classes: [],
    defaultItem: {
      pk_estudante: 0,
      numeroProcesso: "",
      pkPessoa: 0,
      classeSelected: "",
      bi: "",
      idPessoa: "",
      municipio: null,
      idPerfil: null,
      nome: "",
      periodo: "",
      morada: "",
      telefone: "",
      autor: "",
      datanascimento: "",
      data_: "",
      status_2: "",
      email: "",
      sexo: "",
      nomedopai: "",
      nomedamae: "",
      numeroProcesso: null,
      dataemissaobi: null,
      provincia: null,
      instituicao: null,
      instituicaodescricao: "",
      curso: null,
      turma: null,
      numeroProcesso: "",
      matriculaAntiga: "",
    },
    alert: false,
    iconAlert: "",
    alertType: "",
    colorAlert: "",
    msgAlert: "",
    date: null,
    firstStep: true,
    secondStep: false,
    studenteBi: null,
    existingBi: false,
    estudantesCadastrados: null,
    estatisticas: null,
    blockCadastro: false,
    aberturaFecho: [],
    d10: true,
    d11: true,
    d12: true,
    d13: true,
    blockCadastroClasse: false
  }),

  computed: {
    vagasDisponiveis() {
      return (
        parseInt(
          this.editedItem.turma === null || this.editedItem.turma == undefined ? 0 : this.editedItem.turma.capacidade
        ) -
        parseInt(
          this.numeroEstudantesCadastrado.length ? this.numeroEstudantesCadastrado[0].qtdEstudante : 0
        )
      );
    },

    nivelEnsino() {
      return ls.get("nivel");
    }
  },

  watch: {
    menubi(val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = "YEAR"));
    },
    menu(val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = "YEAR"));
    },
    dialog(val) {
      val || this.close();
    },
  },

  async created() {
    try {
      // Fetch data for estudantesCadastrados and estatisticas
      this.estudantesCadastrados = await axios.get('/estudantesCadastrados').then(res => res.data[0]);
      this.estatisticas = await axios.get('/Config_instituicao_estudantes').then(res => res.data[0]);
      this.aberturaFecho = await axios.get('/listAberturaFechoInstituicao').then((res) => res.data);

      if (this.aberturaFecho.length) {
        const descricoes = ["Inscrições 10", "Inscrições 11", "Inscrições 12", "Inscrições 13"];
        descricoes.forEach((descricao, index) => {
          const filtro = this.aberturaFecho.filter(
            (a) => a.descricao === descricao && a.status_2 == 0
          );
          // Definir a variável correspondente de forma dinâmica
          this[`d${index + 10}`] = filtro.length === 0;
        });
      }

      // Validate `estatisticas` data
      if (this.estatisticas) {
        const hasNullOrEmpty = Object.values(this.estatisticas).some(value => value == null || value == 0);
        if (hasNullOrEmpty) {
          this.FecharCard();
          Swal.fire('Informação', 'Deve configurar as estatísticas do anolectivo actual de todas as classes no sistema!', 'info');
        } else {
          // Initialize other data if all values are valid
          this.initializeData();
        }
      }
    } catch (error) {
      Swal.fire('Erro', 'Falha ao carregar dados das estatísticas.', 'error');
    }
  },



  methods: {
    async initializeData() {
      try {
        this.overlay = true;

        const promises = [
          this.fetchProvincias(),
          this.fetchMunicipios(),
          this.fetchCursos(),
          this.fetchTurmas()
        ];

        if (this.nivelEnsino !== 1) {
          promises.push(this.fetchClasses());
        }

        const [provincias, municipiosAll, cursos, turmasAll, classes] = await Promise.all(promises);

        this.provincias = provincias;
        this.municipiosAll = municipiosAll;
        this.cursos = cursos;
        this.turmasAll = turmasAll;

        if (this.nivelEnsino !== 1) {
          this.classes = classes;
        }
      } catch (error) {
        Swal.fire('Informação', 'Erro ao carregar a página!', 'error')
      } finally {
        this.overlay = false
      }
    },

    async fetchProvincias() {
      try {
        const res = await axios.get("/provinciaFindAll");
        return res.data;
      } catch (error) {
        Swal.fire('Informação', 'Erro ao carregar as províncias', 'error');
        throw error;
      }
    },

    async fetchMunicipios() {
      try {
        const res = await axios.get("/municipioFindAll");
        return res.data;
      } catch (error) {
        Swal.fire('Informação', 'Erro ao carregar os municípios!', 'error');
        throw error;
      }
    },

    async fetchCursos() {
      try {
        const res = await axios.get("/cursoInstituicaoFindAllIntegracao");
        return res.data;
      } catch (error) {
        console.log(error, ' o error');
        
        Swal.fire('Informação', 'Erro ao carregar os cursos!', 'error');
        throw error;
      }
    },

    async fetchTurmas() {
      try {
        const res = await axios.get("/turmaFindAll/" + this.idclasse);
        return res.data;
      } catch (error) {
        Swal.fire('Informação', 'Erro ao carregar as turmas!', 'error');
        throw error;
      }
    },

    async fetchClasses() {
      try {
        const res = await axios.get("/classeFindAll2");
        return res.data;
      } catch (error) {
        Swal.fire('Informação', 'Erro ao carregar as classes!', 'error');
        throw error;
      }
    },


    async checkDocNumber() {
      if (this.editedItem.bi) {
        try {
          let response = await axios.get(`/vericarBIEstudante/${this.editedItem.bi}`).then((res) => res.data);
          if (response.length) {
            this.existingBi = true;
            this.studenteBi = response[0];
          }
          else {
            this.existingBi = false;
          }
    
          this.$refs.biField.validate();
          if (this.existingBi) {
            this.firstStep = false;
            let htmlContent = `
              <p style="text-align: center;"><strong style="color: red;">OBS:</strong> O número de bilhete inserido está 
                sendo usado por outro/a estudante. Verifique novamente o número inserido. Se estiver correto e você 
                continua recebendo este aviso, por favor, entre em contato com os administradores do sistema.</p>
              <div style="width: 90%; margin: 10 auto;">
                <div style="display: grid; grid-template-columns: 150px auto;">
                  <div style="text-align: left; border-bottom: 2px solid rgba(0, 0, 0, 0.1);"><strong>Nome:</strong></div>
                  <div style="text-align: right; border-bottom: 2px solid rgba(0, 0, 0, 0.1);"> ${this.studenteBi.nome}</div>
                  <div style="text-align: left; border-bottom: 2px solid rgba(0, 0, 0, 0.1);"><strong>Instituição:</strong></div>
                  <div style="text-align: right; border-bottom: 2px solid rgba(0, 0, 0, 0.1);"> ${this.studenteBi.instituicaodescricao}</div>
                </div>
              </div>`;

              Swal.fire('Bilhete já usado!', htmlContent, "warning")
              this.FecharCard()
          } else {
            if (this.$refs.form.validate()) {
              this.firstStep = false;
              this.secondStep = true;
            }
          }
        } catch (error) {
          Swal.fire(
            "Informação",
            "Erro ao verificar o número de documento!",
            "error"
          );
        }
      }
    },
    getClasse(idclasse) {
      switch (idclasse) {
        case 1:
          return "10ª classe";
        case 2:
          return "11ª classe";
        case 3:
          return "12ª classe";
        case 4:
          return "13ª classe";
      }
    },

    voltarParaPrimeiroStep() {
      this.secondStep = false;
      this.firstStep = true;
    },
    outroDoc() {
      if (this.descricao === "Outro Doc.") {
        this.editedItem.bi = "";
        this.descricao = "Nº do Bi";
        this.mascara = "#########-AA-###";
        this.ruleBI = [
          (value) =>
            value.length === 16 || "Minimo de caracteres exigido( 16 )",
        ];
      } else {
        this.editedItem.bi = "";
        this.descricao = "Outro Doc.";
        this.mascara = "XXXXXXXXXXXXXXXXXXXXXXXXXXXXXX";
        this.ruleBI = [
          (value) =>
            (value.length >= 3 && value.length <= 30) ||
            "Minimo de caracteres exigido( 3 )",
        ];
      }
    },
    saveDatebi(datebi) {
      this.$refs.menubi.save(datebi);
      this.editedItem.dataemissaobi = datebi;
      this.datebi = new Date(datebi).toISOString().substr(0, 10);
    },
    saveDate(date) {
      this.$refs.menu.save(date);
      this.editedItem.datanascimento = date;
      this.date = new Date(date).toISOString().substr(0, 10);
    },
    loadMunicipioComb(provincia) {
      this.municipiosFiltered = this.municipiosAll.filter(
        (municipio) => municipio.idProvincia === provincia.idProvincia
      );
    },
    loadclasse() {
      /**
       * Nivel Ensino
       * 1 - Superioor
       * 2 - Médio
       */
      if (this.nivelEnsino === 1) {
        for (
          let index = 1;
          index <= parseInt(this.editedItem.curso.numero_anos_academicos);
          index++
        ) {
          this.classesFiltered.push({ id: index, descricao: index + "º ano" });
        }
        this.classesFiltered.push({ id: 100, descricao: "Monografia" });
      } else {
        let classe = 10;
        for (let index = 1; index <= 4; index++) {
          this.classesFiltered.push({
            id: index,
            descricao: classe + "ª Classe",
          });
          classe++;
        }
      }
    },

    returnBloqueado(classe) {
      if (classe == 1) return this.d10;
      else if (classe == 2) return this.d11;
      else if (classe == 3) return this.d12;
      else if (classe == 4) return this.d13;
    },

    loadTurmaComb() {
      this.turmasFiltered = [];
      this.editedItem.turma = null;
      this.editedItem.periodo = null;
      this.turmasFiltered = this.turmasAll.filter(
        (t) =>
          t.idCurso === this.editedItem.curso.idCurso &&
          t.idAno_Academico === this.editedItem.classeSelected.id
      );

      if (this.returnBloqueado(this.editedItem.classeSelected.id)) {
        Swal.fire({
          title: 'Informação',
          text: `O cadastramento para a ${this.getClasse(this.editedItem.classeSelected.id)} está bloqueado!`,
          icon: "warning",
          willOpen: () => {
            document.querySelector('.swal2-container').style.zIndex = 9999;
          }
        });
        this.blockCadastroClasse = true;
      } else {
        this.blockCadastroClasse = false;
        const classeKey = 'classe' + this.editedItem.classeSelected.id;
        this.blockCadastro = Number(this.estudantesCadastrados[classeKey]) >= Number(this.estatisticas[classeKey]);
        if (this.blockCadastro) {
          this.result = `Atingiu o limite de cadastro para a ${this.getClasse(this.editedItem.classeSelected.id)}!`
        }
      }
    },

    async ObterNumeroEstudantesTurma() {
      try {
        this.numeroEstudantesCadastrado = await axios
          .post("ObterNumeroIscritoEstudantesTurma", {
            turma: this.editedItem.turma,
          })
          .then((res) => res.data);

        this.editedItem.periodo = this.periodos.filter((p) => p.descricao === this.editedItem.turma.periodo)[0]
      } catch (error) { }
    },

    FecharCard() {
      this.$emit("fecharComponente", false);
    },
    async Guardar() {
      if (this.$refs.form.validate()) {
        try {
          this.overlay = true;
          let params = {
            estudante: this.editedItem,
            nome:
              this.editedItem.nome.length <= 0 || this.editedItem.nome === null
                ? this.editedItem.nome
                : utilitarios.SetNameCapitalize(this.editedItem.nome.trim()),
            nomedopai:
              this.editedItem.nomedopai.length <= 0 ||
                this.editedItem.nomedopai === null
                ? this.editedItem.nomedopai
                : utilitarios.SetNameCapitalize(
                  this.editedItem.nomedopai.trim()
                ),
            nomedamae:
              this.editedItem.nomedamae.length <= 0 ||
                this.editedItem.nomedamae === null
                ? this.editedItem.nomedamae
                : utilitarios.SetNameCapitalize(
                  this.editedItem.nomedamae.trim()
                ),
            autor: ls.get("nomeUsuario"),
            turmaSelected: this.editedItem.turma,
            tipoEstudante: 0,
            telefone: this.editedItem.telefone,
          };
          let result = await axios.post("estudanteInsertOrUpdate", params);

          if (result.data.affectedRows >= 1) {
            Swal.fire(
              "Informação",
              "Estudante cadastrado com sucesso",
              "success"
            );
            this.$emit("fecharComponente", false);
            this.dialog = false;
            this.editedItem = this.defaultItem;
            this.editarDados = false;
          } else if (result.data.status === 1122) {
            // For duplicate entry
            Swal.fire(
              "Informação",
              "<p>Número do Bilhete ou Processo já registrado.</p>",
              "warning"
            );
          } else {
            utilitarios.showAlertMessage(
              "error",
              "Ocorreu um erro ao tentar efectuar a operação"
            );
          }
        } catch (error) {
          utilitarios.showAlertMessage(
            "error",
            "Ocorreu um erro ao tentar efectuar a operação"
          );
        } finally {
          this.overlay = false;
        }
      }
    },

    

   



    // METHODO FOR VALIDATION
    validate() {
      this.$refs.form.validate()
    },
    reset() {
      this.$refs.form.reset();
    },
    resetValidation() {
      this.$refs.form.resetValidation();
    },
    close() {
      this.dialog = false;
      this.$refs.form.resetValidation();
    },


    showAlert() {
      this.alert = true;
      this.tab = 0;
      this.colorAlert = "color:green;";
      this.iconAlert = "done";
      this.alertType = "success";
      this.msgAlert = "Actualização efectuada com sucesso!";
      setTimeout(() => {
        this.alert = false;
      }, 4000);
    }
  }
};
</script>

<style scoped>
.boldText {
  font-weight: bolder;
  font-size: 15 px;
}

span {
  margin-right: 10px;
}

.containerTurma {
  text-align: left;
  border: 1px solid #ccc;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  padding: 5px;
  background-color: #fff;
  height: auto;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  /* Distribui o conteúdo ao longo da altura */
}



.margin-card {
  margin-left: 20px;
  margin-bottom: 10px;
}

.tpaCombox {
  height: 50px;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  padding: 0 3px;
}

.overlay {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 70%;
  height: 40%;
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;
  transform: translate(-50%, -50%);
  max-width: "800px"
}

.slide-item {
  overflow: hidden;
}

.slide-enter-active,
.slide-leave-active {
  transition: transform 0.5s;
}

.slide-enter,
.slide-leave-to {
  transform: translateX(100%);
}

.slide-enter-to,
.slide-leave {
  transform: translateX(0);
}

.alertMessage {
  color: red;
  display: block;
  font-size: 13px;
}
</style>